import type {
  AttendanceMeResponse, AttendanceOverviewResponse, AttendanceWorkplaceShiftGroupsResponse, AttendanceWorkplaceShiftMonitoringResponse,
  AttendanceWorkplaceShiftExtensionCommand, AttendanceWorkplaceShiftExtensionResult,
  AttendanceWorkplaceShiftRetrospectiveClosureCommand, AttendanceWorkplaceShiftRetrospectiveClosureResult,
  CastingRetrospectiveCloseInput, CastingRetrospectiveCloseReceipt
} from '@krafta/shared-types';

import { buildMesUrl, mesHttp } from '@shared/api/mesClient';

export const attendanceApi = {
  async getMe() {
    const response = await mesHttp.get<AttendanceMeResponse>(buildMesUrl('/attendance/me'));
    return response.data;
  },

  async getOverview(params: { limit?: number; cursor?: string | null } = {}) {
    const response = await mesHttp.get<AttendanceOverviewResponse>(
      buildMesUrl('/attendance/overview', {
        limit: params.limit ? String(params.limit) : undefined,
        cursor: params.cursor ?? undefined
      })
    );
    return response.data;
  },

  async getWorkplaceShiftGroups() {
    const response = await mesHttp.get<AttendanceWorkplaceShiftGroupsResponse>(
      buildMesUrl('/attendance/workplace-shift-groups')
    );
    return response.data;
  },

  async getWorkplaceShifts(params: { workplaceId: string; limit?: number; cursor?: string | null }) {
    const response = await mesHttp.get<AttendanceWorkplaceShiftMonitoringResponse>(
      buildMesUrl('/attendance/workplace-shifts', {
        workplaceId: params.workplaceId,
        limit: params.limit === undefined ? undefined : String(params.limit),
        cursor: params.cursor ?? undefined
      })
    );
    return response.data;
  },

  async extendWorkplaceShift(command: AttendanceWorkplaceShiftExtensionCommand) {
    const response = await mesHttp.post<AttendanceWorkplaceShiftExtensionResult>(
      buildMesUrl('/attendance/workplace-shift-extensions'), command
    );
    return response.data;
  },

  async closeMechanicalWorkplaceShiftRetrospectively(command: AttendanceWorkplaceShiftRetrospectiveClosureCommand) {
    const response = await mesHttp.post<AttendanceWorkplaceShiftRetrospectiveClosureResult>(
      buildMesUrl('/mechanical/shifts/retrospective-closures'), command
    );
    return response.data;
  },

  async closeWorkplaceShiftRetrospectively(command: AttendanceWorkplaceShiftRetrospectiveClosureCommand) {
    const response = await mesHttp.post<AttendanceWorkplaceShiftRetrospectiveClosureResult>(
      buildMesUrl('/assembly/shifts/retrospective-closures'), command
    );
    return response.data;
  },

  async closeCastingWorkplaceShiftRetrospectively(command: CastingRetrospectiveCloseInput) {
    const response = await mesHttp.post<CastingRetrospectiveCloseReceipt>(
      buildMesUrl('/injection-molding/assignments/shifts/retrospective-closures'), command
    );
    return response.data;
  }
};
